<template>
  <div class="manual-ft">
    <div class="agree">
      <label for="ckbagree">
        本功能相关服务由海南创业星空科技有限公司提供，请您在使用本功能前仔细阅读
        <a
          :href="privacyLink"
          @click="clickPrivacyLink(23)"
          target="_blank"
        >《PDF编辑转换器用户协议》</a>
        及
        <a
          :href="privacyPolicy"
          @click="clickPrivacyLink(24)"
          target="_blank"
        >《隐私政策》</a>
      </label>
    </div>
    <div class="other-icons">
      <div
        @click="handleLoign"
        class="login_btn"
      >
        <span class="icon_wrapper">
          <i :class="['sprite-login', changeClass]" />
        </span>
        <span>{{ changeText }}</span>
      </div>
      <div
        @click="clickQQLogin"
        class="login_btn"
      >
        <span class="icon_wrapper">
          <i class="sprite-login sprite-login-qq" />
        </span>
        <span>QQ</span>
      </div>
    </div>
  </div>
</template>

<script>
import { PRIVACYLINK, URL_LIST, REPORT_LOGIN_TYPE, PRIVACY_POLICY } from '@/config/dataMap'

import login from '@/client/modules/login.js'
import common from '@/client/modules/common.js'
import { formatDate } from '@/utils/shared'

export default {
  name: 'ChangeLoginType',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      privacyLink: PRIVACYLINK,
      privacyPolicy: PRIVACY_POLICY
    }
  },

  computed: {
    isPhoneLogin: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },

    changeClass () {
      return this.isPhoneLogin ? 'sprite-login-wechat' : 'sprite-login-phone'
    },

    changeText () {
      return this.isPhoneLogin ? '微信' : '手机号'
    }
  },

  methods: {
    handleLoign () {
      this.isPhoneLogin = !this.isPhoneLogin
      this.$emit('emitHandleLoign')

      const { phone, wechat } = REPORT_LOGIN_TYPE
      const loginType = this.isPhoneLogin ? phone : wechat
      this.reportClick({ login_type: loginType })
    },

    clickPrivacyLink (clickNum) {
      this.reportClick({ click: clickNum })
    },

    clickQQLogin () {
      this.reportClick({ click: 6, login_type: REPORT_LOGIN_TYPE.qq })
      common.API.userLogin({
        url: `${URL_LIST.qq}&time=${new Date().getTime()}`,
        width: 1000,
        height: 500,
      })
    },

    reportClick ({ click = 0, login_type = 0 }) {
      const show_time = formatDate(new Date())

      login.REPORT.reportLoginPageClick({
        page_click: click,
        show_time,
        login_type
      })
    }
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/css/sprite-login.scss';

.manual-ft {
  margin: 0 auto;
  padding: 0 17px;
  color: #636d78;
  font-size: 12px;

  .other-icons {
    font-size: 14px;
    color: #636d78;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 18px;
  }

    .login_btn{
      overflow: hidden;
      width: 48px;
      cursor: pointer;
      color: #555555;
      &:first-of-type{
        margin-right: 32px;
      }
      .icon_wrapper {
        width: 48px;
        height: 48px;
        display: inline-block;
        position: relative;
        margin-bottom: 8px;
        i {
          position: relative;
        }
        &:hover {
          i {
            left: -48px;
          }
        }
        &:active {
          i {
            left: -96px;
          }
        }
      }
    }

  .agree {
    margin-top: 10px;
    font-size: 12px;
    display: flex;
    align-items: center;

    label {
      text-align: center;
      color: #666;
    }

    a {
      color: #BD6603;
    }
  }
}
</style>
